// @flow strict
import React, { useEffect } from 'react';
import Helmet from 'react-helmet';
import Layout from '../components/Layout';
import { useSiteMetadata } from '../hooks';

// The notes live in Notion. Keeping the destination behind a route on this
// domain means the link can be shared as mrunalmendgudle.com/twil and the
// target can change later without chasing the URL everywhere it was posted.
const TWIL_URL = 'https://cloud-catboat-987.notion.site/TWIL-This-Week-I-learnt-2f9e077a0faa804f8c43d877811066d6';

const DESCRIPTION = 'Notes on what I learnt each week — from books, articles, podcasts and '
  + 'the many small and big TIL moments.';

const TwilTemplate = () => {
  const { title: siteTitle } = useSiteMetadata();

  useEffect(() => {
    window.location.replace(TWIL_URL);
  }, []);

  return (
    <Layout title={`TWIL - ${siteTitle}`} description={DESCRIPTION} fullWidth>
      {/* The meta refresh carries visitors with JavaScript disabled, and is a
          plain static tag so it works on any host. */}
      <Helmet>
        <meta httpEquiv="refresh" content={`0; url=${TWIL_URL}`} />
        <link rel="canonical" href={TWIL_URL} />
      </Helmet>

      <div
        style={{
          minHeight: '60vh',
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center',
          padding: '40px 20px',
          textAlign: 'center'
        }}
      >
        <p style={{ color: 'var(--color-gray)', margin: '0 0 12px' }}>
          Taking you to my Notion…
        </p>
        <a href={TWIL_URL} style={{ color: 'var(--color-primary)' }}>
          Open “This Week I learnt”
        </a>
      </div>
    </Layout>
  );
};

export default TwilTemplate;
